module.exports = __webpack_public_path__ + "img/061.6810faad.png";